import { IntroComponent } from '../onboarding/components/intro/intro.component';
import { Plugins, Question } from './global.models';
export interface Plugins {
  Appsee: any;
}

export interface Question {
  question: string;
  answers: string[];
  type: string;
  name?: string;
  placeholder?: string;
  steps?: number;
  id: Number;
  subQuestion?: Question;
}
export interface Window {
  plugins: Plugins;
  Appsee: any;
  mixpanel: any;
}

export interface Plugins {
  appsFlyer: any;
}

export interface Environment {
  production: string;
  loggerConfig: {};
  enableTracing: boolean;
  endPoint: string;
  thirdParties: {
    appsee: string;
    appsFlyer: string;
    mixpanel: string;
  };
}

// Type definitions for Apache Cordova Camera plugin
// Project: https://github.com/apache/cordova-plugin-camera
// Definitions by: Microsoft Open Technologies Inc <http://msopentech.com>
// Definitions: https://github.com/DefinitelyTyped/DefinitelyTyped
// 
// Copyright (c) Microsoft Open Technologies Inc
// Licensed under the MIT license.
export interface Navigator {
  /**
   * This plugin provides an API for taking pictures and for choosing images from the system's image library.
   */
  camera: Camera;
}

/**
* This plugin provides an API for taking pictures and for choosing images from the system's image library.
*/
export interface Camera {
  /**
   * Removes intermediate photos taken by the camera from temporary storage.
   * @param onSuccess Success callback, that called when cleanup succeeds.
   * @param onError Error callback, that get an error message.
   */
  cleanup(
    onSuccess: () => void,
    onError: (message: string) => void): void;
  /**
   * Takes a photo using the camera, or retrieves a photo from the device's image gallery.
   * @param cameraSuccess Success callback, that get the image
   * as a base64-encoded String, or as the URI for the image file.
   * @param cameraError Error callback, that get an error message.
   * @param cameraOptions Optional parameters to customize the camera settings.
   */
  getPicture(
    cameraSuccess: (data: string) => void,
    cameraError: (message: string) => void,
    cameraOptions?: CameraOptions): void;
  // Next will work only on iOS
  //getPicture(
  //    cameraSuccess: (data: string) => void,
  //    cameraError: (message: string) => void,
  //    cameraOptions?: CameraOptions): CameraPopoverHandle;
}

export interface CameraOptions {
  /** Picture quality in range 0-100. Default is 50 */
  quality?: number;
  /**
   * Choose the format of the return value.
   * Defined in navigator.camera.DestinationType. Default is FILE_URI.
   *      DATA_URL : 0,   Return image as base64-encoded string
   *      FILE_URI : 1,   Return image file URI
   *      NATIVE_URI : 2  Return image native URI
   *          (e.g., assets-library:// on iOS or content:// on Android)
   */
  destinationType?: number;
  /**
   * Set the source of the picture.
   * Defined in navigator.camera.PictureSourceType. Default is CAMERA.
   *      PHOTOLIBRARY : 0,
   *      CAMERA : 1,
   *      SAVEDPHOTOALBUM : 2
   */
  sourceType?: number;
  /** Allow simple editing of image before selection. */
  allowEdit?: boolean;
  /**
   * Choose the returned image file's encoding.
   * Defined in navigator.camera.EncodingType. Default is JPEG
   *      JPEG : 0    Return JPEG encoded image
   *      PNG : 1     Return PNG encoded image
   */
  encodingType?: number;
  /**
   * Width in pixels to scale image. Must be used with targetHeight.
   * Aspect ratio remains constant.
  */
  targetWidth?: number;
  /**
   * Height in pixels to scale image. Must be used with targetWidth.
   * Aspect ratio remains constant.
   */
  targetHeight?: number;
  /**
   * Set the type of media to select from. Only works when PictureSourceType
   * is PHOTOLIBRARY or SAVEDPHOTOALBUM. Defined in nagivator.camera.MediaType
   *      PICTURE: 0      allow selection of still pictures only. DEFAULT.
   *          Will return format specified via DestinationType
   *      VIDEO: 1        allow selection of video only, WILL ALWAYS RETURN FILE_URI
   *      ALLMEDIA : 2    allow selection from all media types
   */
  mediaType?: number;
  /** Rotate the image to correct for the orientation of the device during capture. */
  correctOrientation?: boolean;
  /** Save the image to the photo album on the device after capture. */
  saveToPhotoAlbum?: boolean;
  /**
   * Choose the camera to use (front- or back-facing).
   * Defined in navigator.camera.Direction. Default is BACK.
   *      FRONT: 0
   *      BACK: 1
   */
  cameraDirection?: number;
  /** iOS-only options that specify popover location in iPad. Defined in CameraPopoverOptions. */
  popoverOptions?: CameraPopoverOptions;
}

/**
* A handle to the popover dialog created by navigator.camera.getPicture. Used on iOS only.
*/
interface CameraPopoverHandle {
  /**
   * Set the position of the popover.
   * @param popoverOptions the CameraPopoverOptions that specify the new position.
   */
  setPosition(popoverOptions: CameraPopoverOptions): void;
}

/**
* iOS-only parameters that specify the anchor element location and arrow direction
* of the popover when selecting images from an iPad's library or album.
*/
interface CameraPopoverOptions {
  x: number;
  y: number;
  width: number;
  height: number;
  /**
   * Direction the arrow on the popover should point. Defined in Camera.PopoverArrowDirection
   * Matches iOS UIPopoverArrowDirection constants.
   *      ARROW_UP : 1,        
   *      ARROW_DOWN : 2,
   *      ARROW_LEFT : 4,
   *      ARROW_RIGHT : 8,
   *      ARROW_ANY : 15
   */
  arrowDir: number;
}

export declare var Camera: {
  // Camera constants, defined in Camera plugin
  DestinationType: {
    DATA_URL: number;
    FILE_URI: number;
    NATIVE_URI: number
  }
  Direction: {
    BACK: number;
    FRONT: number;
  }
  EncodingType: {
    JPEG: number;
    PNG: number;
  }
  MediaType: {
    PICTURE: number;
    VIDEO: number;
    ALLMEDIA: number;
  }
  PictureSourceType: {
    PHOTOLIBRARY: number;
    CAMERA: number;
    SAVEDPHOTOALBUM: number;
  }
  // Used only on iOS
  PopoverArrowDirection: {
    ARROW_UP: number;
    ARROW_DOWN: number;
    ARROW_LEFT: number;
    ARROW_RIGHT: number;
    ARROW_ANY: number;
  }
};

export interface Response {
  Code: number;
  Description: string;
  Data: any;
  Errors: ResultErrorModel[];
  Status: number;
  Type: number;
  CreatedOn: Date;
}
export interface ResultErrorModel {
  Code: number;
  Description: string;
  Data: object;
}

export interface PensionSummary {
  TotalAggregate?: Number;
  Categories?: PensionCategory[];
}
export interface PensionCategory {
  CategoryType?: CategoryType;
  Products?: PensionProduct[];
  ProductsCount?: Number;
}
export interface PensionProduct {
  Id?: string;
  RiskLevel?: Number;
  EmployerName?: string;
  InvestmentTrack?: string;
  StartDate?: string;
  LiquidityDate?: string;
  State?: PensionProductState;
  PlanStatus?: PlanStatus;
  TotalAggregate?: Number;
  CumulativeReturn1?: Number;
  CumulativeReturn3?: Number;
  CumulativeReturn5?: Number;
  ManagementFeesPremium?: Number;
  ManagementFeesAccrual?: Number;
  YieldComparedToRecommendation?: Number;
  Manufacturer?: Manufacturer;
  PensionRecommendation?: PensionRecommendation;
  Beneficiaries?: PensionBeneficiary[];
}
export interface Manufacturer {
  ID?: string;
  Name?: string;
  Code?: Number;
  PrivateCompany?: string;
  PrivateCompanyOperation?: string;
  Version?: string;
}
export interface PensionRecommendation {
  Id?: string;
  AmountIfUpgradePerformed?: Number;
  YieldComparedToProduct?: Number;
}
export interface PensionBeneficiary {
  FirstName?: string;
  LastName?: string;
}

enum PlanStatus {
  Active = 1,
  FrozenOrNotActive = 2,
  Canceled = 4,
  TempRisk = 8,
  BlockedToDeposits = 16,
  EndOfPeriod = 32,
  AutoTempRisk = 64,
  InsuranceCoverageSave = 128,
  Irrelevant = 256,
  IndependentCalculatorImplementation = 512
}

export enum PensionProductState {
  /// <summary>
  /// The state of the product is valid and no actions are needed to perform
  /// </summary>
  Valid = 1,

  /// <summary>
  /// There's a problem with the product and an action is needed to be performed.
  /// If there is a recommendation, an update is recommended.
  /// If no recommendation exists, The customer should consult an expert on this product
  /// </summary>
  Problem = 2,

  /// <summary>
  /// The product is after an action performed but not finished yet.
  /// </summary>
  InProgress = 4,

  /// <summary>
  /// The customer performed an action and the update is completed.
  /// Probably waiting for mislaka update
  /// </summary>
  FinishedDigitalProcess = 8
}


export enum CategoryType {
  BituahMenahalim = 1,
  Pensia = 2,
  KupotGemel = 3,
  Kranot = 4,
  Risk = 6,
  Mortage = 7,
  PrivateRisk = 15,
  Deposit = 16,
  Saving = 17,
  DefaultPension = 23,
  Loan = 24
}

export interface InsuranceExpandedSummary {
  CriticalIllness: HealthInsuranceCalculationModel;
  Nursing: HealthInsuranceCalculationModel;
  PersonalAccidents: HealthInsuranceCalculationModel;
  Business: HealthInsuranceCalculationModel;
  Apartment: HealthInsuranceCalculationModel;
  Other: HealthInsuranceCalculationModel;
  Vehicle: HealthInsuranceCalculationModel;
  HealthInsurance: HealthInsuranceCalculationModel;
  LossWorkabillity: InsuranceCalculationResponse;
  Survivors: InsuranceCalculationResponse;
  LifeInsurance: InsuranceCalculationResponse;
}
export interface HealthInsuranceCalculationModel {
  OverallStatus: OverallStatus;
  SubPoliciesOverallStatus: SubPoliciesOverallStatusModel;
  Policies: Policy[];
}
export interface InsuranceCalculationResponse {
  CurrentAmount: Number;
  Gap: Number;
  ExpectedAmount: Number;
  IsValid: OverallStatus;
  Premium: Number;
}
export interface SubPoliciesOverallStatusModel {
  ConsultAndExams: OverallStatus;
  Medicines: OverallStatus;
  Transplants: OverallStatus;
  SurgeriesAbroad: OverallStatus;
  SurgeriesHere: OverallStatus;
  AdditionalCoverages: string[];
}
export interface Policy {
  ID: string;
  Type: PolicyType;
  MonthlyPremium: Number;
  StartDate: string;
  ManufacturerCode: Number;
  PolicyNumber: string;
  CoverageAmount: Number;
  ClassificationPlan: PolicyClassificationPlan;
  SubPolicies: SubPolicy[];
}
export interface SubPolicy {
  Name: string;
  Type: SubPolicyType;
}


export enum OverallStatus {
  Valid = 1,
  Multiple = 2,
  MoreThanExpected = 4,
  LessThanExpected = 8,
  MultipleAndLessThanExpected = 16,
  NotExists = 32
}

export enum PolicyType {
  HealthInsurance = 1,
  LifeInsurance = 2,
  LossWorkabillity = 4,
  Nursing = 8,
  CriticalIllness = 16,
  PersonalAccidents = 32,
  Vehicle = 64,
  Apartment = 128,
  Business = 256,
  Other = 512
}

export enum PolicyClassificationPlan {
  Personal = 1,
  Group = 2
}

export enum SubPolicyType {
  /// <summary>
  /// תאונות אישיות
  /// </summary>
  PersonalAccidents = 1,
  /// <summary>
  /// ניתוחים משלים שב"ן
  /// </summary>
  ComplementarySurgeryAndAdditionalHealthServices = 2,
  /// <summary>
  /// השתלות
  /// </summary>
  Transplants = 4,
  /// <summary>
  /// תרופות
  /// </summary>
  Medicines = 8,
  /// <summary>
  /// תרופות והרחבה לתרופות
  /// </summary>
  MedicinesAndExtra = 9,
  /// <summary>
  /// ניתוחים בחו"ל
  /// </summary>
  SurgeriesAbroad = 16,
  /// <summary>
  /// ביטוח למקרה מוות
  /// </summary>
  DeathBenefit = 32,
  /// <summary>
  /// סיעודי
  /// </summary>
  Nursing = 64,
  /// <summary>
  /// ייעוץ ובדיקות
  /// </summary>
  ConsultingAndExaminations = 128,
  /// <summary>
  /// ביטוח למקרה מוות חיסכון טהור
  /// </summary>
  DeathBenefitPureSavings = 256,
  /// <summary>
  /// ביטוח למקרה מוות חיסכון משולב
  /// </summary>
  DeathBenefitIntegratedSavings = 512,
  /// <summary>
  /// ניתוחים מהשקל הראשון
  /// </summary>
  FirstShekelSurgeries = 1024,
  /// <summary>
  /// חבילת כיסויים
  /// </summary>
  Coverages = 2048,
  /// <summary>
  /// אבדן כושר עבודה שחרור ופיצוי
  /// </summary>
  LossWorkAbilityReleaseCompensation = 4096,
  /// <summary>
  /// מחלות קשות
  /// </summary>
  CriticalIllness = 8192,
  /// <summary>
  /// אחר
  /// </summary>
  Other = 16384,
  /// <summary>
  /// רכב חובה
  /// </summary>
  Vehicle = 32768,
  /// <summary>
  /// ביטוח מבנה
  /// </summary>
  Apartment = 65536,
  /// <summary>
  /// ביטוח עסק
  /// </summary>
  Business = 131072,
  /// <summary>
  /// ביטוח מקיף - רכב
  /// </summary>
  ComprehensiveInsurance = 262144
}

export class UpdatePhoneNumber{
  OldPhoneNumber: string;
  NewPhoneNumber: string;
}

export class DeleteUser{
  PrimaryIdentifier: string;
  SecondaryIdentifier: string;
}
export interface AuthenticatedStatusModel {
  MislakaData: MislakaCustomerInfo;
  MislakaDateRequest: Date;
  FilledRiskLevelForm: boolean;
  Credits: number;
  PensionSummary: CustomerPensionData;
  InsuranceMountainRequestDate: string;
}

export interface MislakaCustomerInfo  {
  MislakaRequestDate: string;
  DaysPastFromRequest: number;
  IsUserAllowedToUpdateData: number;
  IsUserHasProductsInProgress: boolean;
  AmountToUpdate: number;
}

export interface CustomerPensionData {
  PensionTotalAmount: number;
  OldPensionAmount: number;
  ExpectedPensionAmountOneTime: number;
  ExpectedPensionAmountMonthly: number;
  HasHealthDeclaration: boolean;
}

